import { combineReducers } from 'redux'

import { reducer as eventsEmbed } from 'lib/api/events'

export const rootReducer = combineReducers({
  eventsEmbed
})
